// utils/download.js
// Salva uma resposta blob (axios) em disco usando o nome/extensão CORRETOS.
//
// Motivação: ao baixar via `URL.createObjectURL` + `a.download`, o navegador
// usa exatamente o nome definido em `a.download` e ignora o header
// `Content-Disposition` do servidor. Se a extensão for cravada no código
// (ex.: ".docx"), um PDF vindo do backend acaba salvo como ".docx".
//
// Aqui a extensão passa a seguir o conteúdo real: primeiro tenta o nome que o
// servidor enviou no Content-Disposition; se não houver, usa o nome base e
// ajusta a extensão pelo MIME type do blob.

const EXT_BY_MIME = {
  "application/pdf": "pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
  "application/msword": "doc",
  "application/zip": "zip",
};

// Extrai o filename de um header Content-Disposition, cobrindo tanto o formato
// RFC 5987 (`filename*=UTF-8''...`) quanto o simples (`filename="..."`).
function filenameFromDisposition(disposition) {
  if (!disposition) return null;
  const star = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(disposition);
  if (star && star[1]) {
    try {
      return decodeURIComponent(star[1].trim().replace(/^"|"$/g, ""));
    } catch {
      /* cai para o formato simples abaixo */
    }
  }
  const plain = /filename="?([^";]+)"?/i.exec(disposition);
  return plain ? plain[1].trim() : null;
}

// Garante que `base` carregue a extensão que corresponde ao conteúdo do blob.
function ensureExtension(base, mime) {
  const ext = EXT_BY_MIME[mime];
  if (!ext) return base; // MIME desconhecido: mantém o nome como veio
  return base.replace(/\.(pdf|docx?|zip)$/i, "") + "." + ext;
}

/**
 * Baixa uma resposta blob do axios com o nome de arquivo correto.
 * Prioridade: filename do Content-Disposition → nome base com a extensão
 * derivada do MIME type do blob.
 *
 * @param {import("axios").AxiosResponse} res  resposta com responseType "blob"
 * @param {string} fallbackBase  nome usado quando o servidor não informa um
 */
export function saveBlobResponse(res, fallbackBase) {
  const serverName = filenameFromDisposition(res?.headers?.["content-disposition"]);
  const name = serverName || ensureExtension(fallbackBase, res?.data?.type);
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export default saveBlobResponse;
